import {
    RouteRecordRaw
} from 'vue-router'

const root: RouteRecordRaw = {
    path: '/',
    redirect: '/home'
}

export default root
